export default "__VITE_ASSET__6rA6nsa6__"